// ignore-string-externalization

import React from 'react';
import { Videos } from '../../features/Videos';

const VideosPage = () => {
  return <Videos />;
};

export default VideosPage;
